module.exports = __webpack_public_path__ + "static/media/1.73d9938b.jpg";